/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ sets: NonNullable<unknown>, muscle: NonNullable<unknown> }} Quick_Workout_Notice_Muscle_CeilingInputs */

const en_us2_quick_workout_notice_muscle_ceiling = /** @type {(inputs: Quick_Workout_Notice_Muscle_CeilingInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Stopped at ${i?.sets} sets of ${i?.muscle}: more than that in one session is volume that doesn't pay.`)
};

const pt_br2_quick_workout_notice_muscle_ceiling = /** @type {(inputs: Quick_Workout_Notice_Muscle_CeilingInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Parou em ${i?.sets} séries de ${i?.muscle}: mais que isso numa sessão é volume que não rende.`)
};

const es_419_quick_workout_notice_muscle_ceiling = /** @type {(inputs: Quick_Workout_Notice_Muscle_CeilingInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Se detuvo en ${i?.sets} series de ${i?.muscle}: más que eso en una sesión es volumen que no rinde.`)
};

const pt_pt2_quick_workout_notice_muscle_ceiling = /** @type {(inputs: Quick_Workout_Notice_Muscle_CeilingInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Parou em ${i?.sets} séries de ${i?.muscle}: mais do que isso numa sessão é volume que não compensa.`)
};

const fr_fr2_quick_workout_notice_muscle_ceiling = /** @type {(inputs: Quick_Workout_Notice_Muscle_CeilingInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Arrêté à ${i?.sets} séries pour ${i?.muscle} : au-delà, en une séance, c'est du volume qui ne rapporte rien.`)
};

const de_de2_quick_workout_notice_muscle_ceiling = /** @type {(inputs: Quick_Workout_Notice_Muscle_CeilingInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Bei ${i?.sets} Sätzen für ${i?.muscle} gestoppt: Mehr in einer Einheit ist Volumen, das sich nicht lohnt.`)
};

const it_it2_quick_workout_notice_muscle_ceiling = /** @type {(inputs: Quick_Workout_Notice_Muscle_CeilingInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Fermato a ${i?.sets} serie di ${i?.muscle}: di più in una sola sessione è volume che non rende.`)
};

/**
* | output |
* | --- |
* | "Stopped at {sets} sets of {muscle}: more than that in one session is volume that doesn't pay." |
*
* @param {Quick_Workout_Notice_Muscle_CeilingInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const quick_workout_notice_muscle_ceiling = /** @type {((inputs: Quick_Workout_Notice_Muscle_CeilingInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Quick_Workout_Notice_Muscle_CeilingInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_quick_workout_notice_muscle_ceiling(inputs)
	if (locale === "es-419") return es_419_quick_workout_notice_muscle_ceiling(inputs)
	if (locale === "pt-PT") return pt_pt2_quick_workout_notice_muscle_ceiling(inputs)
	if (locale === "fr-FR") return fr_fr2_quick_workout_notice_muscle_ceiling(inputs)
	if (locale === "de-DE") return de_de2_quick_workout_notice_muscle_ceiling(inputs)
	if (locale === "it-IT") return it_it2_quick_workout_notice_muscle_ceiling(inputs)
	return en_us2_quick_workout_notice_muscle_ceiling(inputs)
});
export { quick_workout_notice_muscle_ceiling as "quick-workout.notice_muscle_ceiling" }